var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermometerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 10,
    viewBox: "0 0 62 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.607843,
    y: 0.607843,
    width: 60.7843,
    height: 8.5098,
    rx: 4.2549,
    stroke: "#61A578",
    strokeWidth: 1.21569
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.4706,
    height: 9.72549,
    rx: 4.86275,
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerIcon);
export default __webpack_public_path__ + "static/media/thermometer_icon.a91bb6e870510f7eea39502bd77f279f.svg";
export { ForwardRef as ReactComponent };